/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CouponData } from './CouponData';
import {
    CouponDataFromJSON,
    CouponDataFromJSONTyped,
    CouponDataToJSON,
    CouponDataToJSONTyped,
} from './CouponData';

/**
 * 
 * @export
 * @interface CouponPerformance
 */
export interface CouponPerformance {
    /**
     * 
     * @type {Array<CouponData>}
     * @memberof CouponPerformance
     */
    coupons?: Array<CouponData>;
}

/**
 * Check if a given object implements the CouponPerformance interface.
 */
export function instanceOfCouponPerformance(value: object): value is CouponPerformance {
    return true;
}

export function CouponPerformanceFromJSON(json: any): CouponPerformance {
    return CouponPerformanceFromJSONTyped(json, false);
}

export function CouponPerformanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponPerformance {
    if (json == null) {
        return json;
    }
    return {
        
        'coupons': json['coupons'] == null ? undefined : ((json['coupons'] as Array<any>).map(CouponDataFromJSON)),
    };
}

export function CouponPerformanceToJSON(json: any): CouponPerformance {
    return CouponPerformanceToJSONTyped(json, false);
}

export function CouponPerformanceToJSONTyped(value?: CouponPerformance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coupons': value['coupons'] == null ? undefined : ((value['coupons'] as Array<any>).map(CouponDataToJSON)),
    };
}

